import vm from "../main";
import axios from "axios";

export default class StyleJsonService {
  static async getStyleJson(clientId, cdnUrl, sasToken) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    const url = `${cdnUrl}/${clientId}/styles/dashboard-style.json${sasToken}&version=${Date.now()}`;
    try {
      response = await axios.get(url);
    } catch (error) {
      console.error(error);
      response = await axios.get(`https://mapscdn.pointr.tech/style/9.2/light_PCD.json`);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data;
  }

  static async getEsriAttributionText() {
    const token =
      "AAPTxy8BH1VEsoebNVZXo8HurDpHkqBWTOJSHKI6qIOiAS5wn2nuXuahomj3727Hwrobyb_S0isxSYLJfZ-yc-uiT5YIoY5xV16cwWOylmIVgcFUYdbIQmx6mfSOTSqGGjX4JU5JJLXz_2SkW_udqgiRnmmx0Phuc71IYn7-zEvywi2kG0sLXwiOhLKROI-HRcgcp7bwFukIYRTnwxoFe79qgoSEBAu46WkGkWxnGBLLHe0.AT1_GMQk8vUf";
    const basemapStylesUrl = `https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/arcgis/streets?token=${token}`;

    let response;
    try {
      response = await axios.get(basemapStylesUrl);
    } catch (error) {
      console.error("Error fetching Esri attribution:", error);
    }

    const esriCopyrightText =
      response?.data?.sources?.esri?.copyrightText || response?.data?.sources?.esri?.attribution;

    return esriCopyrightText;
  }
}
